import { takeEvery, put, call } from "redux-saga/effects"
import {
  // DOMAINS
  GET_DOMAINS,
  ADD_DOMAIN,
  UPDATE_DOMAIN,
  DELETE_DOMAIN,
  GET_CREDENTIALS,
  // SUBSCRIPTIONS
  GET_SUBS,
  ADD_SUB,
  UPDATE_SUB,
  DELETE_SUB
} from './actionTypes';
import { 
  getDomainsSuccess,
  getDomainsFail,
  getCredentialsSuccess,
  getCredentialsFail,
  addDomainSuccess,
  addDomainFail,
  updateDomainSuccess,
  updateDomainFail,
  deleteDomainSuccess,
  deleteDomainFail,
  getSubsSuccess,
  getSubsFail,
  addSubSuccess,
  addSubFail,
  updateSubSuccess,
  updateSubFail,
  deleteSubSuccess,
  deleteSubFail,
  showLoading, 
  hideLoading 
} from './actions';
import {
  getDomains,
  getCredentials,
  addDomain,
  updateDomain,
  deleteDomain,
  getSubs,
  addSub,
  updateSub,
  deleteSub
} from "../../helpers/backend_helper"
import { showToast } from '../../components/Toast';

function* fetchDomains() {
  try {
    yield put(showLoading(true))
    const response = yield call(getDomains)
    yield put(getDomainsSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getDomainsFail(error))
  }
}
function* onGetCredentials({ payload: domain }) {
  try {
    // yield put(showLoading(true))
    const response = yield call(getCredentials, domain)
    // showToast("New Domain is added")
    yield put(getCredentialsSuccess(response))
    // yield put(hideLoading(false))
  } catch (error) {
    // yield put(showLoading(true))
    yield put(getCredentialsFail(error.response))
  }
}
function* onAddDomain({ payload: domain }) {
  try {
    yield put(showLoading(true))
    const response = yield call(addDomain, domain)
    showToast("New Domain is added")
    yield put(addDomainSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(addDomainFail(error.response))
  }
}
function* onUpdateDomain({ payload: domain }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updateDomain, domain)
    showToast("Changes Successfully Applied")
    yield put(updateDomainSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updateDomainFail(error))
  }
}
function* onDeleteDomain({ payload: domain }) {
  try {
    yield put(showLoading(true))
    const response = yield call(deleteDomain, domain)
    showToast("Domain is deleted from the system")
    yield put(deleteDomainSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(deleteDomainFail(error))
  }
}

// SUBSCRIPTIONS
function* fetchSubs() {
  try {
    yield put(showLoading(true))
    const response = yield call(getSubs)
    yield put(getSubsSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getSubsFail(error))
  }
}
function* onAddSub({ payload: sub }) {
  try {
    yield put(showLoading(true))
    const response = yield call(addSub, sub)
    showToast("New Subcription is added")
    yield put(addSubSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(addSubFail(error.response))
  }
}
function* onUpdateSub({ payload: sub }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updateSub, sub)
    showToast("Changes Successfully Applied")
    yield put(updateSubSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updateSubFail(error))
  }
}
function* onDeleteSub({ payload: sub }) {
  try {
    yield put(showLoading(true))
    const response = yield call(deleteSub, sub)
    showToast("Subcription is deleted from the system")
    yield put(deleteSubSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(deleteSubFail(error))
  }
}

function* domainsSaga() {
  yield takeEvery(GET_DOMAINS, fetchDomains)
  yield takeEvery(GET_CREDENTIALS, onGetCredentials)
  yield takeEvery(ADD_DOMAIN, onAddDomain)
  yield takeEvery(UPDATE_DOMAIN, onUpdateDomain)
  yield takeEvery(DELETE_DOMAIN, onDeleteDomain)

  yield takeEvery(GET_SUBS, fetchSubs)
  yield takeEvery(ADD_SUB, onAddSub)
  yield takeEvery(UPDATE_SUB, onUpdateSub)
  yield takeEvery(DELETE_SUB, onDeleteSub)
}

export default domainsSaga;